import useSWR from 'swr'
import {fetcher} from '../services/http.service'
import {GetDeliveryInfoResponse} from './apiTypes'
import {queries} from "./queries";

export function useDeliveryInfo(tracking_number?: string) {
    const {data, error, isLoading, mutate} = useSWR<GetDeliveryInfoResponse>(
        tracking_number ? queries.shipping.deliveryinfo(tracking_number) : null,
        fetcher,
        {revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false}
    )

    console.log('useDeliveryInfo', data)
    return {
        mutate,
        deliveryInfo: data,
        isLoading,
        isError: error,
    }
}
